var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.35 113.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ad0b202e-76f9-499c-9dee-fc05c6b29f82{stroke:#4d4d4d;stroke-miterlimit:10;stroke-width:0.76px;fill:url(#f22373ab-a9d7-4627-922f-6a0658c15220);}.b568b363-aa71-4419-9e2d-4a08048c6fec{fill:none;stroke:#fdf9f0;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f22373ab-a9d7-4627-922f-6a0658c15220",
    x1: 0.38,
    y1: 56.67,
    x2: 112.97,
    y2: 56.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ae0ce1b5-da7d-4094-a6f7-8e2a9dd1d081",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac8d9750-995b-40a1-b3cb-776e7c69555c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ad0b202e-76f9-499c-9dee-fc05c6b29f82",
    cx: 56.67,
    cy: 56.67,
    r: 56.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b568b363-aa71-4419-9e2d-4a08048c6fec",
    points: "24.16 58.82 47.46 82.11 91.18 38.39"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.5fd5293103713fc2dc9cd51e683aa4d3.svg";
export { ForwardRef as ReactComponent };